<div class="content-holder">
  <!-- <div class="header align-items-center">
    <p class="title">
      <span>{{ t('common.cultures') }}</span>
    </p>
    <div class="subtitle">
      {{ t('profile.cultures_help') }}
    </div>
  </div> -->
  
  <div class="row body">
    <div class="col-12">
      @if (error()) {
        <alert [type]="'danger'" [dismissible]="true" class="mb-4">
          <span *transloco="let t">{{ t(error()!) }}</span>
        </alert>
      }
      
      <section class="cultures-section">
        <div class="section-heading">
          <h2 class="flex-grow-1" *transloco="let t; scope: 'profile'">{{ t('profile.cultures_primary_heading') }}</h2>
          <div class="spinner-border text-primary heading-loader" role="status" [style.opacity]="loading() ? 1 : 0" [style.transition]="'opacity 0.3s ease-in-out'">
            <span class="visually-hidden">Loading...</span>
          </div>
          <span class="section-meta">{{ selectedPrimaryCultureIds().length }}/{{ PRIMARY_CULTURES_MAX_SELECTED }}</span>
        </div>
        
        <div class="subtitle" *transloco="let t; scope: 'profile'">
          {{ t('profile.cultures_primary_help') }}
        </div>
        <label class="form-label visually-hidden" for="primary-culture-search" *transloco="let t">{{ t('navigation.search') }}</label>
        <input
           *transloco="let t"
          #primaryCultureSearchInput
          id="primary-culture-search"
          type="text"
          class="form-control input-lg"
          [formControl]="primaryCultureSearchControl"
          [typeahead]="availableCulturesForPrimary()"
          typeaheadOptionField="name"
          [typeaheadMinLength]="0"
          [typeaheadWaitMs]="150"
          (typeaheadOnSelect)="onPrimarySelected($event)"
          [placeholder]="t('common.start_typing')"
          [disabled]="loading() || selectedPrimaryCultureIds().length >= PRIMARY_CULTURES_MAX_SELECTED"
        />

        @if (selectedPrimaryCultures().length) {
          <div class="cultures-grid mt-3">
            @for (culture of selectedPrimaryCultures(); track culture.id) {
              <multisite-avatar-pill
                [text]="culture.name"
                [imageUrl]="cloudinary_base_url+'w_40,c_fill,ar_1:1,r_max/flags/'+culture.flag?.hash+'.png'"
                class="selectable-item"
                [removalMode]="true"
                [disabled]="isPending(culture.id)"
                (selected)="removeFromPrimary(culture)"
              ></multisite-avatar-pill>
            }
          </div>
        } @else {
          <div class="cultures-empty mt-3 text-muted" *transloco="let t">
            {{ t('common.none_yet') }}
          </div>
        }
      </section>

      <section class="cultures-section mt-4">
        <div class="section-heading">
          <h2 class="flex-grow-1" *transloco="let t;scope: 'profile'">{{ t('profile.cultures_other_heading') }}</h2>
          <div class="spinner-border text-primary heading-loader" role="status" [style.opacity]="loading() ? 1 : 0" [style.transition]="'opacity 0.3s ease-in-out'">
            <span class="visually-hidden">Loading...</span>
          </div>
          <span class="section-meta">{{ selectedOtherCultureIds().length }}/{{ OTHER_CULTURES_MAX_SELECTED }}</span>
        </div>

         <div class="subtitle" *transloco="let t; scope: 'profile'">
          {{ t('profile.cultures_other_help') }}
        </div>
        <label class="form-label visually-hidden" for="other-culture-search" *transloco="let t">{{ t('navigation.search') }}</label>
        <input
          #otherCultureSearchInput
           *transloco="let t"
          id="other-culture-search"
          type="text"
          class="form-control input-lg"
          [formControl]="otherCultureSearchControl"
          [typeahead]="availableCulturesForOther()"
          typeaheadOptionField="name"
          [typeaheadMinLength]="0"
          [typeaheadWaitMs]="150"
          (typeaheadOnSelect)="onOtherSelected($event)"
          [placeholder]="t('common.start_typing')"
          [disabled]="loading() || selectedOtherCultureIds().length >= OTHER_CULTURES_MAX_SELECTED"
        />

        @if (selectedOtherCultures().length) {
          <div class="cultures-grid mt-3">
            @for (culture of selectedOtherCultures(); track culture.id) {
              <multisite-avatar-pill
                [text]="culture.name"
                [imageUrl]="cloudinary_base_url+'w_24,c_fill,ar_1:1,r_max/flags/'+culture.flag?.hash+'.png'"
                class="selectable-item"
                [removalMode]="true"
                [compact]="true"
                [disabled]="isPending(culture.id)"
                (selected)="removeFromOther(culture)"
              ></multisite-avatar-pill>
            }
          </div>
        } @else {
          <div class="cultures-empty mt-3 text-muted" *transloco="let t">
            {{ t('common.none_yet') }}
          </div>
        }
      </section>
    </div>
  </div>
</div>
